// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createEvent } from "effector";
import { TemplateDTO } from "../../utils/htmlTemplate/dto/template.dto";

export const setTemplates = createEvent<TemplateDTO[]>("SET_TEMPLATES");
export const findTemplateByName = createEvent<TemplateDTO>(
  "FIND_TEMPLATE_BY_NAME"
);
